import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mobile-menu",
  "use": "icon-mobile-menu-usage",
  "viewBox": "0 0 57.619 57.619",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 57.619 57.619\" id=\"icon-mobile-menu\">\r\n  <path id=\"icon-mobile-menu_Shape\" d=\"M43.215,38.413H0v-4.8H43.215v4.8Zm0-16.806H0v-4.8H43.215v4.8Zm0-16.806H0V0H43.215V4.8Z\" transform=\"translate(7.202 9.603)\" fill=\"#fff\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol